import { Typography } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { IconListRow } from "@sinch/components/IconListRow/IconListRow";
import { MdsNumbersXs, MdsPercentXs } from "@sinch/icons";
import { CompanyHeaderFragment } from "./fragments.types";

/**
 * Company registration number and VAT number rows. Each row is skipped when the
 * company does not have that identifier filled in.
 */
export const CompanyRegistrationInfo: FC<{ company: CompanyHeaderFragment }> = ({ company }) => {
  const { t } = useTranslation();

  return (
    <>
      {company.ico && (
        <IconListRow icon={MdsNumbersXs} iconAlign="firstLine" iconSize="xs">
          <Typography variant="descriptionSmall">
            <Typography variant="descriptionSmallBold">{t("CompanyHeader.registrationNumber")}:</Typography>{" "}
            {company.ico}
          </Typography>
        </IconListRow>
      )}
      {company.dic && (
        <IconListRow icon={MdsPercentXs} iconAlign="firstLine" iconSize="xs">
          <Typography variant="descriptionSmall">
            <Typography variant="descriptionSmallBold">{t("CompanyHeader.vatNumber")}:</Typography> {company.dic}
          </Typography>
        </IconListRow>
      )}
    </>
  );
};
